import { render } from "./PublisherTable.vue?vue&type=template&id=7972d420&scoped=true"
import script from "./PublisherTable.vue?vue&type=script&lang=js"
export * from "./PublisherTable.vue?vue&type=script&lang=js"

import "./PublisherTable.vue?vue&type=style&index=0&id=7972d420&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7972d420"]])

export default __exports__